import React from 'react';
import styled from 'styled-components';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';

const AdminDatePickerWrapperStyled = styled.div`
  position: relative;
  gap: 16px;
  font-size: 15px;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.neutral900};
  display: inline-block;
  padding: 12px 12px 16px 12px;
  border: 1px solid ${({ theme }) => theme.colors.neutral900};
  box-shadow: none;
  border-radius: 20px;

  .flatpickr-calendar.rangeMode.animate.inline {
    margin: 0 !important;
  }

  .flatpickr-day.inRange {
    background: #f7f7f7;
    border-color: #f7f7f7;
    border-radius: 50%;
    box-shadow: none;
  }

  .flatpickr-day.selected,
  .flatpickr-day.startRange,
  .flatpickr-day.endRange,
  .flatpickr-day.selected.inRange,
  .flatpickr-day.startRange.inRange,
  .flatpickr-day.endRange.inRange,
  .flatpickr-day.selected:focus,
  .flatpickr-day.startRange:focus,
  .flatpickr-day.endRange:focus,
  .flatpickr-day.selected:hover,
  .flatpickr-day.startRange:hover,
  .flatpickr-day.endRange:hover,
  .flatpickr-day.selected.prevMonthDay,
  .flatpickr-day.startRange.prevMonthDay,
  .flatpickr-day.endRange.prevMonthDay,
  .flatpickr-day.selected.nextMonthDay,
  .flatpickr-day.startRange.nextMonthDay,
  .flatpickr-day.endRange.nextMonthDay {
    background: ${({ theme }) => theme.colors.primary900};
    border-color: ${({ theme }) => theme.colors.primary900};
    color: #fff;
    border-radius: 50%;
    box-shadow: none !important;
  }

  .flatpickr-day.selected.endRange,
  .flatpickr-day.startRange.endRange,
  .flatpickr-day.endRange.endRange,
  .flatpickr-day.selected.startRange,
  .flatpickr-day.startRange.startRange {
    border-radius: 50%;
  }

  .flatpickr-day.today {
    border-color: ${({ theme }) => theme.colors.primary900};
  }

  .flatpickr-calendar {
    border: none;
    border: none;
    box-shadow: none;
  }

  .flatpickr-weekday {
    font-weight: normal !important;
  }

  .flatpickr-weekdays {
    height: 50px;
  }

  .flatpickr-input {
    display: none;
    pointer-events: none;
  }

  .flatpickr-current-month .flatpickr-monthDropdown-months {
    -moz-appearance: none !important; /* Firefox */
    -webkit-appearance: none !important; /* Safari and Chrome */
    appearance: none !important;
  }

  .flatpickr-current-month .flatpickr-monthDropdown-months:hover {
    background: none;
    color: ${({ theme }) => theme.colors.primary900};
  }
`;

const styledFlatpickr = styled(Flatpickr)`
  border: 1px solid ${({ theme }) => theme.colors.neutral900};
`;

export const Calendar = () => {
  return (
    <AdminDatePickerWrapperStyled>
      <Flatpickr
        options={{
          minDate: '2017-01-01',
          defaultDate: new Date(),
          inline: true
        }}
      />
    </AdminDatePickerWrapperStyled>
  );
};
